var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row wrapper_flex"},[_c('div',{staticClass:"termsdesc"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.termsTitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.termsDescription)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }